var map = {
	"./CodingLab.png": 301,
	"./CodingLab.webp": 302,
	"./Edison.png": 303,
	"./Edison.webp": 304,
	"./HTML_JS_CSS.png": 305,
	"./HTML_JS_CSS.webp": 306,
	"./Hopscotch.png": 307,
	"./Hopscotch.webp": 308,
	"./ILPlatform_Books.png": 26,
	"./ILPlatform_Books.webp": 72,
	"./ILPlatform_Programme12-16.png": 75,
	"./ILPlatform_Programme12-16.webp": 78,
	"./ILPlatform_Programme5-7.png": 76,
	"./ILPlatform_Programme5-7.webp": 79,
	"./ILPlatform_Programme8-11.png": 77,
	"./ILPlatform_Programme8-11.webp": 80,
	"./ILPlatform_Project.png": 74,
	"./ILPlatform_Project.webp": 73,
	"./LegoEducation.png": 309,
	"./LegoEducation.webp": 310,
	"./MicroBit.png": 311,
	"./MicroBit.webp": 312,
	"./Python.png": 313,
	"./Python.webp": 314,
	"./Scratch.png": 315,
	"./Scratch.webp": 316,
	"./ScratchJr.png": 317,
	"./ScratchJr.webp": 318,
	"./SpheroEdu.png": 319,
	"./SpheroEdu.webp": 320,
	"./SwiftPlaygrounds.png": 321,
	"./SwiftPlaygrounds.webp": 322,
	"./WonderWorkshop.png": 323,
	"./WonderWorkshop.webp": 324
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 300;